import * as QS from "util/query-string";

/*
 * Add query string searching to your component.
 *
 * NOTE: This exploits history reference to location. Otherwise, you must
 * pass in location to each function call.
 */
class Searcher {
  constructor(history) {
    this._history = history;

    this.getSearchQuery = this.getSearchQuery.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  _getLocationParams() {
    return QS.parse(this._history.location.search);
  }

  getSearchQuery() {
    const params = this._getLocationParams();

    return params.q || "";
  }

  onSearchChange(query) {
    const { pathname } = this._history.location;
    const params = this._getLocationParams();

    params.page = 1;
    if (query) {
      params.q = query;
    } else {
      delete params.q;
    }

    this._history.push({ pathname, search: QS.stringify(params) });
  }
}

export { Searcher };
